import { takeEvery, select, put } from 'redux-saga/effects'

import * as actions from './audio.actions'
import * as selectors from './audio.selectors'
import { Howl, Howler } from 'howler'
import * as gameSelector from '../game.selectors'
import * as phasesSelectors from '../../../Mars/Phases/phases.selectors'
import { Api, Auth } from '../../../Core'

/**
 *  play a sound
 */

export function* playHowlSound(action) {
  console.log('playHowlSound called with id:', action.data, 'type:', typeof action.data)
  const audioDisabled = yield select(gameSelector.getAudioStatus)
  console.log('audioDisabled:', audioDisabled)
  if (audioDisabled == undefined || !audioDisabled) {
    const audios = yield select(selectors.getOnlyAudio)
    console.log('Available audios:', audios.map(a => ({ id: a.id, type: typeof a.id, url: a.url })))
    let selectedAudio = audios.find((obj) => obj.id == action.data)
    console.log('selectedAudio:', selectedAudio)

    if (!selectedAudio) {
      console.warn(`Audio with id ${action.data} not found`)
      return
    }

    // If it's a looping background audio, remove existing instances first
    if (selectedAudio.loop && selectedAudio.type === 'background') {
      console.log('Removing existing background audio instances before creating new one')
      // Find and stop all existing Howls with the same src
      Howler._howls.forEach(howl => {
        if (howl._src && howl._src[0] && howl._src[0].includes('Fase')) {
          console.log('Stopping and unloading existing background Howl:', howl._src[0])
          howl.stop()
          howl.unload()
        }
      })
    }

    let url = selectedAudio.url
    console.log('Audio URL:', url)
    let autoPlay = selectedAudio.autoplay == undefined ? true : selectedAudio.autoplay
    let soundVolume =
      selectedAudio.volume == undefined ? (selectedAudio.volume = 0.5) : selectedAudio.volume
    let preload =
      selectedAudio.preload == undefined ? (selectedAudio.preload = true) : selectedAudio.preload

    // Resume audio context if suspended (required by modern browsers)
    if (Howler.ctx && Howler.ctx.state === 'suspended') {
      try {
        yield Howler.ctx.resume()
      } catch (err) {
        console.warn('Failed to resume audio context:', err)
      }
    }

    if (url) {
      console.log('Creating Howl instance with URL:', url, 'loop:', selectedAudio.loop, 'volume:', soundVolume)
      const howl = new Howl({
        id: action.data,
        src: [url],
        autoplay: false, // Don't use autoplay, call play() explicitly
        loop: selectedAudio.loop,
        volume: soundVolume,
        preload: preload,
        onload: function() {
          console.log('Howl loaded successfully for id:', action.data)
          if (autoPlay) {
            console.log('Calling play() on loaded Howl')
            this.play()
          }
        },
        onloaderror: function(id, error) {
          console.error('Howl load error for id:', id, 'error:', error)
        },
        onplayerror: function(id, error) {
          console.error('Howl play error for id:', id, 'error:', error)
        }
      })
      console.log('Howl instance created, state:', howl.state())
    } else {
      console.warn('No URL for audio:', action.data)
    }
    if (selectedAudio.loop) {
      //Salva el current SOUND BGM
    }
  }
}
export function* removeHowlSound() {
  Howler._howls.length >= 0 ? yield Howler.unload() : null
}

export function* disableAudio(action) {
  let bool = action.data
  const userInfo = yield select(Auth.selectors.getUserInfo)
  if (bool !== undefined) {
    console.log('disableAudio called with bool:', bool)
    yield (Howler.noAudio = bool)

    if (bool) {
      // Disabling audio - remove all sounds
      console.log('Disabling audio - removing all sounds')
      yield removeHowlSound()
    } else {
      // Enabling audio - restart background music for current phase
      const currentPhase = yield select(phasesSelectors.getCurrentPhase)
      console.log('Enabling audio - current phase:', currentPhase)
      if (currentPhase !== undefined) {
        console.log('Dispatching playHowlAudio for phase:', currentPhase)
        yield put(actions.playHowlAudio(currentPhase))
      }
    }

    yield Api.put(
      `/audioDisabled?groupId=${userInfo.licenseData.groupId}&playerId=${userInfo.licenseId}`,
      {},
      { bool: bool }
    )
  }
}

export function* playSound(soundName) {
  const audios = yield select(selectors.getUrlAudio)
  let selectedAudio = audios.filter((obj) => obj.id == soundName.data)
  const iOS = !!navigator.userAgent.match(/iPhone|iPod|iPad/)
  if (
    iOS &&
    selectedAudio[0] &&
    (selectedAudio[0].url !== 'undefined' || selectedAudio[0].url !== null)
  ) {
    let url = selectedAudio[0].url
    yield new Audio(url).play()
  }
}

export function* playCurrentBackground() {
  const backgroundStillPlaying = yield select(selectors.getBackgroundAudios)
  const iOS = !!navigator.userAgent.match(/iPhone|iPod|iPad/)
  if (
    iOS &&
    backgroundStillPlaying &&
    (backgroundStillPlaying[0].url !== 'undefined' || backgroundStillPlaying[0].url !== null)
  ) {
    let url = backgroundStillPlaying[0].url
    yield new Audio(url).play()
  }
}

/**
 *   sagas entrypoint
 */
export function* sagas() {
  yield takeEvery(actions.PLAY_AUDIO, playSound)
  yield takeEvery(actions.PLAY_BACKGROUND, playCurrentBackground)
  yield takeEvery(actions.PLAY_HOWL_AUDIO, playHowlSound)
  yield takeEvery(actions.REMOVE_HOWL_AUDIO, removeHowlSound)
  yield takeEvery(actions.DISABLE_AUDIO, disableAudio)
}
